import { startOfDateInLocalTimezone } from '@seen/core/dates'
import { format } from 'date-fns'
import type { ReactNode } from 'react'
import type { TimelineListItem } from '#src/hooks/useTimelineListItems.ts'
import { TimelineItemComponent } from '#src/pages/participants/timeline/TimelineItemComponent.tsx'

export function TimelineListRow({
  item,
}: {
  item: TimelineListItem
}): ReactNode {
  switch (item.type) {
    case 'date-group':
      return (
        <h5>{format(startOfDateInLocalTimezone(item.dateString), 'MMMM d')}</h5>
      )
    case 'item':
      return <TimelineItemComponent key={item.key} item={item.item} />
  }
}
